import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UsuarioService } from 'src/app/service/usuario.service';
import { Usuario } from './usuario';

@Component({
  selector: 'app-usuario-consulta',
  templateUrl: './usuario-consulta.component.html',
  styleUrls: [
    './usuario.component.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class UsuarioConsultaComponent {

  mensagemErros: String[] = [];
  usuarios: Usuario[] = [];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  tipoFiltro = 'ID';
  parametro = '';
  ordemColunasTabela = ['id', 'username', 'name', 'ativo', 'acoes'];
  tipoFiltros: string[] = ['ID', 'Nome'];
  consultaRealizada = false;

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private usuarioService: UsuarioService,
  ) { }

  consultar() {
    const req$ = this.parametro?.trim()
      ? this.usuarioService.buscarComFiltro(this.pagina, this.tamanho, this.parametro, this.tipoFiltro)
      : this.usuarioService.list(this.pagina, this.tamanho);
    req$.subscribe((response) => {
      this.usuarios = response.content;
      this.totalElementos = response.totalElements;
      this.pagina = response.number;
      this.consultaRealizada = true;
    }, () => {
      this.snackBar.open('Erro ao consultar usuários.', 'ERRO', { duration: 2500 });
    });
  }

  listarUsuarios(pagina: number, tamanho: number) {
    this.usuarioService.list(pagina, tamanho).subscribe((response) => {
      this.usuarios = response.content;
      this.totalElementos = response.totalElements;
      this.pagina = response.number;
      this.consultaRealizada = true;
    });
  }

  novo() {
    this.router.navigate(['/usuario/form']);
  }

  editar(id: number) {
    this.router.navigate(['/usuario/form', id]);
  }

  paginar(event: PageEvent) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    if (this.consultaRealizada && this.parametro?.trim()) {
      this.consultar();
    } else if (this.consultaRealizada) {
      this.listarUsuarios(this.pagina, this.tamanho);
    }
  }
}
